import etiquetasTemplate from '../views/EtiquetasDetailView/EtiquetasDetailView.html';
import EtiquetasCtrl from '../views/EtiquetasDetailView/EtiquetasDetailView';

function config($stateProvider) {

	$stateProvider
		.state('app.main', {
			url: '/main',
			template: etiquetasTemplate,
			controller: EtiquetasCtrl,
			controllerAs: 'operacao',
			publicAccess: true
		});
}

config.$inject = ['$stateProvider'];
export default config;

